import reducer from './menuSlice'
import { menuActions } from './menuSlice'
import * as menuSelectors from './selectors'

export { menuSelectors, menuActions }
export default reducer
